/* eslint-disable no-shadow */

import Products from '@gameday/common/components/form/Pages/Products'
/* eslint-disable no-param-reassign */
import { differenceBy } from 'lodash'
import { useState } from 'react'
import styled from 'styled-components'

const StyledProducts = styled.div`
  --custom-primary-color: ${props => props.formSettings.textLinkColour};
`

export const getProductsTotalQuantityPerSession = (session, registrations, currentRegistration, formType) => {
  const mergingProducts = []
  Object.values(registrations).forEach(rego => {
    const regoProducts = {
      ...(formType === 'Event' && { ...(rego.newSubEventProducts || {}) }),
      ...(formType === 'Event' && { ...(rego.newProducts || {}) }),
      ...(rego.newAddOnProducts || {}),
    }
    if (rego.sfid === currentRegistration?.sfid) {
      session.products.forEach(sessionProduct => {
        const productFound = mergingProducts.find(product => product.id === sessionProduct.id)
        if (productFound) {
          productFound.quantity += parseInt(sessionProduct.quantity, 10) || 0
        } else {
          mergingProducts.push(sessionProduct)
        }
      })
    } else {
      Object.keys(regoProducts).forEach(pid => {
        const productFound = mergingProducts.find(product => product.id === pid)
        if (productFound) {
          productFound.quantity += parseInt(regoProducts[pid].quantity, 10) || 0
        } else if (
          Object.keys(regoProducts).length &&
          Object.keys(regoProducts[pid]).length &&
          regoProducts[pid].formProductId
        ) {
          mergingProducts.push({
            quantity: parseInt(regoProducts[pid].quantity, 10) || 0,
            id: pid,
            formProductId: regoProducts[pid].formProductId,
          })
        }
      })
    }
  })
  return mergingProducts
}

const ProductsComponent = ({
  registrations,
  memberProducts,
  currentRegistration,
  products,
  productGroups,
  startTimer,
  urlParams = {},
  setValue,
  next,
  validateSession,
  createAndValidateSession,
  sessionId,
  timezones,
  formType,
  feeConfigurations,
  paymentGateway,
  formSettings,
  displayPriceAsZero,
  subEvents,
  isTeamEvent,
  teamFormType,
  team,
  teamData,
  setTeam,
  ...rest
}) => {
  const [formError, setFormError] = useState(undefined)

  const isTeamRego = isTeamEvent && teamFormType === 'Register A Team'
  const prods = isTeamRego ? team?.products : products
  const prodGroups = isTeamRego ? team?.productGroups : productGroups

  const checkSelectedSubEventProducts = (
    subEvents = [],
    products = [],
    selectedProducts = [],
    selectedSubEvents = {}
  ) => {
    let mappedSubEvents = {}
    subEvents.forEach(s => {
      const products = []
      s.products.forEach(p => !p.isMandatory && products.push(p.sfid))
      const rps = s.relatedProducts.reduce((ac, rp) => {
        ac[rp.sfid] = products
        return ac
      }, {})
      mappedSubEvents = { ...rps, ...mappedSubEvents }
    })
    const sp = selectedProducts.map(p => ({ sfid: p.id, ...p }))
    const mergedProducts = differenceBy(products, sp, 'sfid')

    mergedProducts.forEach(p => {
      if (Object.keys(mappedSubEvents).includes(p.sfid)) {
        mappedSubEvents[p.sfid].forEach(m => {
          delete selectedSubEvents[m]
        })
      }
    })

    return selectedSubEvents
  }

  const fp = prods.filter(p => !p.isForSubEvent)

  const registrationProducts = isTeamRego ? teamData?.teamProducts : currentRegistration?.newProducts

  return (
    <StyledProducts className="products-page" formSettings={formSettings}>
      <Products
        products={fp}
        productGroups={prodGroups}
        formData={{
          birthdate: currentRegistration?.birthdate,
          gender: currentRegistration?.gender,
          memberTypes: currentRegistration?.memberTypes,
          timezones,
        }}
        paidProducts={currentRegistration?.products || []}
        displayPriceAsZero={displayPriceAsZero}
        // eslint-disable-next-line consistent-return
        onSelected={values => {
          const products = Object.keys(values).reduce((a, k) => {
            const purchase = values[k] || {}
            if (!purchase.checked) {
              return a
            }
            a.push({
              id: k,
              quantity: Number(purchase.quantity),
              formProductId: Number(purchase.formProductId),
              attributeId: purchase.attributeId,
              attributeValue: purchase.attributeValue,
              optionIds: purchase.optionIds,
            })
            return a
          }, [])

          const selectedSubEventProducts = checkSelectedSubEventProducts(
            subEvents,
            fp,
            products,
            currentRegistration?.newSubEventProducts || []
          )

          const hasLimitedProducts = products.some(p => {
            const fullProduct = fp.find(pr => pr.sfid === p.id)
            return fullProduct && fullProduct.remainingProductQuantity != null
          })

          if (formType === 'event' || hasLimitedProducts) {
            const session = {
              source: 'Products',
              products,
            }

            if (isTeamRego) {
              setTeam({
                teamProducts: values,
                teamSubEventProducts: selectedSubEventProducts,
              })
              return next()
            }

            // eslint-disable-next-line consistent-return
            const validateCallback = response => {
              if (response.success) {
                startTimer(true)
                setValue({
                  newProducts: values,
                  newSubEventProducts: selectedSubEventProducts,
                })

                return next()
              }
              setFormError(response.message)
            }

            if (sessionId) {
              return validateSession(
                {
                  ...session,
                  products: getProductsTotalQuantityPerSession(session, registrations, currentRegistration),
                },
                validateCallback
              )
            }
            createAndValidateSession(session, validateCallback)
          } else {
            setValue({ newProducts: values })
            return next()
          }
        }}
        preselectedProduct={urlParams.product}
        formType={formType}
        initialValues={registrationProducts || []}
        next={() => {}}
        formError={formError}
        feeConfigurations={feeConfigurations}
        paymentGateway={paymentGateway}
        isTeamEvent={isTeamEvent}
        teamFormType={teamFormType}
        teamData={teamData}
        {...rest}
      />
    </StyledProducts>
  )
}

export default ProductsComponent
